angular.module('classicListTwoLevelDirective',[])
    .directive('classicListTwoLevel',[function(){
        return {
            restrict:'EA',
            scope:{
                //选择列表
                selectStatus:"=",
                //选择的数据
                selectList:"=",
                //必选项
                states:"=",
                selectOneLevel:'='
            },
            templateUrl:'./utils/classicListTwoLevel/classicListTwoLevel.html',
            link:function($scope,ele,attr){
                /**
                 * [callback description]点击
                 *
                 * @param   {[type]}  e  [e description]点击的值
                 *
                 * @return  {[type]}     [return description]
                 */
                $scope.callback=function(e){
                    $scope.selectList.secondClassId=e
                };
                $scope.getClassicListTwoLevel =function(){
                    $scope.selectOneLevel()
                }
            }
        }
    }])